// @flow

import { Alert, type AlertProps } from '@gandi/reshaped';

type Props = {
  messages: Array<string | { __html: string }>,
  ...AlertProps,
};

export function AlertBlock({
  messages,
  color = 'informative',
  ...rest
}: Props): React.MixedElement {
  const props: AlertProps = {
    color,
    attributes: {
      style: {
        marginBottom: 'var(--rs-unit-x4)',
        width: '100%',
      },
    },
  };

  return (
    <Alert {...props} {...rest}>
      {messages.map((message, index) => {
        const currentContent =
          typeof message !== 'string'
            ? { dangerouslySetInnerHTML: message }
            : { children: message };

        // eslint-disable-next-line react/no-array-index-key
        return <p {...currentContent} key={index} />;
      })}
    </Alert>
  );
}
